import React, { useEffect } from 'react';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { PopupContainer } from './styles';
import { useLocation } from 'react-router-dom';


const WhatsAppPopup: React.FC = () => {

    const Whatsap = 'https://api.whatsapp.com/send/?phone=5531982213102&text&type=phone_number&app_absent=0';
    const location = useLocation();
    const [currentPath, setCurrentPath] = React.useState(location.pathname);

    const handleWhatsAppClick = () => {
        const url = `${Whatsap}`;
        window.open(url, '_blank');
    };


    useEffect(() => {
    }, [location, currentPath]);
  return (
    <>
      {currentPath !== '/midiaembh' && (
      <PopupContainer onClick={handleWhatsAppClick}>
        <WhatsAppIcon style={{ color: 'white', fontSize: '30px' }} />
      </PopupContainer>
    )}
    </>
  );
};

export default WhatsAppPopup;
